<template>
  <div>
    <base-confirm
      v-if="visible"
      @close="$emit('close')"
      @confirmed="onConfirmed"
      size="max-w-xl"
      :message="`Faktur akan divalidasi ke gudang. ${
        !minPriceReached
          ? 'Total harga kurang dari minimal belanja, apakah'
          : 'Apakah'
      } Anda yakin data yang dibuat sudah benar?`"
      :type="!minPriceReached ? 'warning' : 'success'"
      title="Validasi Penjualan"
      icon-type="badge"
      visible
    >
      <template #content>
        <Alert
          v-if="hasTransferWarning"
          type="warning"
          message="Pastikan nomor dan nama rekening untuk transfer dan qris sama dengan di metode pembayaran"
        />
      </template>
    </base-confirm>
    <loading v-if="loading" />
  </div>
</template>

<script>
import Alert from '@/components/base/AlertMessage.vue';
import BaseConfirm from '@/components/base/BaseConfirm.vue';
import { requestMixin } from '@/mixins/request/request';
import { mapActions } from 'vuex';

export default {
  components: { Alert, BaseConfirm },
  mixins: [requestMixin],
  props: {
    visible: Boolean,
    orderId: String,
    paymentId: String,
    payments: Array,
    totalPrice: Number,
    minPrice: Number,
    withMinPriceWarning: Boolean,
    validationData: Object,
    hasTransferWarning: Boolean,
  },
  emits: ['close', 'confirmed'],
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    minPriceReached() {
      if (!this.withMinPriceWarning) {
        return true;
      }

      return this.totalPrice >= this.minPrice;
    },
  },
  methods: {
    ...mapActions({
      createAlert: 'alert/createAlert',
    }),
    async onConfirmed() {
      this.loading = true;

      const [, err] = await this.request(
        `/api/v1/orders/${this.orderId}/-actions/validateOrder`,
        {
          method: 'patch',
          data: this.validationData,
        }
      );

      this.$emit('close');

      if (err) {
        this.createAlert({
          data: 'Gagal Memvalidasi Faktur',
          detail: this.getRequestErrorMessage(err),
          type: 'confirm',
          status: 'error',
        });
      } else {
        if (this.paymentId && this.payments && this.payments.length) {
          await this.storePayment();
        }
        this.$emit('confirmed');
      }

      this.loading = false;
    },
    async storePayment() {
      await Promise.all(
        this.payments.map((payment) =>
          this.request(`/api/v1/payment-methods`, {
            method: 'post',
            data: {
              data: {
                type: 'payment-methods',
                attributes: {
                  payment_amount: Number(payment.amount.replace(/\D/g, '')),
                  receipt_number: payment.receiptNumber,
                },
                relationships: {
                  order: {
                    data: {
                      type: 'orders',
                      id: this.orderId,
                    },
                  },
                  payment: {
                    data: {
                      type: 'payments',
                      id: this.paymentId,
                    },
                  },
                  ...(payment.officeBankId
                    ? {
                        'office-bank': {
                          data: {
                            type: 'office-banks',
                            id: payment.officeBankId,
                          },
                        },
                      }
                    : {}),
                  'payment-method-type': {
                    data: {
                      type: 'payment-method-types',
                      id: payment.paymentMethodTypeId,
                    },
                  },
                },
              },
            },
          })
        )
      );
    },
  },
};
</script>
